import { render, staticRenderFns } from "./OrganizationAndUser.vue?vue&type=template&id=11bb98c8"
import script from "./OrganizationAndUser.vue?vue&type=script&lang=js"
export * from "./OrganizationAndUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports